module.exports = __webpack_public_path__ + "static/media/appledark.e92831d0.jpg";